module.exports = __webpack_public_path__ + "static/media/logo_OCB.a8b5a427.svg";